var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStanfordTeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4704.945,
    height: 3664.786,
    viewBox: "0 0 4704.945 3664.786",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "team_work",
    "data-name": "team work",
    transform: "translate(-1798.279 -720.063)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elements",
    transform: "translate(186.5 546.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1509",
    "data-name": "Group 1509",
    transform: "translate(260)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1500",
    "data-name": "Group 1500",
    transform: "translate(742.993 235.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1377",
    "data-name": "Group 1377",
    transform: "translate(744.731 426.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3843",
    "data-name": "Path 3843",
    d: "M1968.123,3295.709a60.409,60.409,0,0,1-60.42,60.42H404.02a60.41,60.41,0,0,1-60.42-60.42V308.32a60.409,60.409,0,0,1,60.42-60.42H1907.7a60.409,60.409,0,0,1,60.42,60.42Z",
    transform: "translate(-343.6 -247.9)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3844",
    "data-name": "Path 3844",
    d: "M1963.738,306.371V417.954H343.6V306.371c0-33.621,26.312-58.471,59.933-58.471H1905.754C1938.888,247.9,1963.738,272.75,1963.738,306.371Z",
    transform: "translate(-343.6 -247.9)",
    fill: "#c4ccce"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1300",
    "data-name": "Group 1300",
    transform: "translate(65.78 51.65)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_449",
    "data-name": "Ellipse 449",
    cx: 39.955,
    cy: 36.544,
    rx: 39.955,
    ry: 36.544,
    transform: "translate(266.531)",
    fill: "#f6f6f8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_450",
    "data-name": "Ellipse 450",
    cx: 39.955,
    cy: 36.544,
    rx: 39.955,
    ry: 36.544,
    transform: "translate(139.356)",
    fill: "#f6f6f8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_451",
    "data-name": "Ellipse 451",
    cx: 39.955,
    cy: 36.544,
    rx: 39.955,
    ry: 36.544,
    fill: "#f6f6f8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3845",
    "data-name": "Path 3845",
    d: "M1486.974,290.3c0-17.054-10.72-30.7-23.388-30.7h-994.5c-13.156,0-23.388,13.643-23.388,30.7h0c0,17.054,10.72,30.7,23.388,30.7h994.5c12.669,0,23.389-13.643,23.389-30.7Z",
    transform: "translate(51.792 -202.591)",
    fill: "#f6f6f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_773",
    "data-name": "Rectangle 773",
    width: 1339.964,
    height: 564.734,
    transform: "translate(142.28 284.56)",
    fill: "#f6f6f8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1319",
    "data-name": "Group 1319",
    transform: "translate(141.914 940.411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1302",
    "data-name": "Group 1302",
    transform: "translate(477.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1301",
    "data-name": "Group 1301"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3846",
    "data-name": "Path 3846",
    d: "M494.088,489.626H816.167c31.185,0,31.185-48.726,0-48.726H494.088c-31.185,0-31.185,48.726,0,48.726Z",
    transform: "translate(-470.7 -440.9)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1304",
    "data-name": "Group 1304"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1303",
    "data-name": "Group 1303"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3847",
    "data-name": "Path 3847",
    d: "M396.479,489.626h374.7c31.185,0,31.185-48.726,0-48.726h-374.7c-31.672,0-31.672,48.726,0,48.726Z",
    transform: "translate(-372.725 -440.9)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1306",
    "data-name": "Group 1306",
    transform: "translate(695.198 98.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1305",
    "data-name": "Group 1305"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3848",
    "data-name": "Path 3848",
    d: "M538.788,509.926H772.673c31.185,0,31.185-48.726,0-48.726H538.788c-31.185,0-31.185,48.726,0,48.726Z",
    transform: "translate(-515.4 -461.2)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1308",
    "data-name": "Group 1308",
    transform: "translate(237.295 98.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1307",
    "data-name": "Group 1307"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3849",
    "data-name": "Path 3849",
    d: "M445.179,509.926H798.442c31.185,0,31.185-48.726,0-48.726H445.179c-31.672,0-31.672,48.726,0,48.726Z",
    transform: "translate(-421.425 -461.2)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1310",
    "data-name": "Group 1310",
    transform: "translate(0 98.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1309",
    "data-name": "Group 1309"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3850",
    "data-name": "Path 3850",
    d: "M396.479,509.926H531.45c31.185,0,31.185-48.726,0-48.726H396.479c-31.672,0-31.672,48.726,0,48.726Z",
    transform: "translate(-372.725 -461.2)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1312",
    "data-name": "Group 1312",
    transform: "translate(469.231 197.827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1311",
    "data-name": "Group 1311"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3851",
    "data-name": "Path 3851",
    d: "M492.779,530.226H952.265c31.185,0,31.185-48.726,0-48.726H492.779c-31.672,0-31.672,48.726,0,48.726Z",
    transform: "translate(-469.025 -481.5)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1314",
    "data-name": "Group 1314",
    transform: "translate(183.697 197.827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1313",
    "data-name": "Group 1313"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3852",
    "data-name": "Path 3852",
    d: "M434.179,530.226h183.21c31.185,0,31.185-48.726,0-48.726H434.179c-31.672,0-31.672,48.726,0,48.726Z",
    transform: "translate(-410.425 -481.5)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1316",
    "data-name": "Group 1316",
    transform: "translate(763.414 296.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1315",
    "data-name": "Group 1315"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3853",
    "data-name": "Path 3853",
    d: "M552.788,550.526H718.457c31.185,0,31.185-48.726,0-48.726H552.788c-31.185,0-31.185,48.726,0,48.726Z",
    transform: "translate(-529.4 -501.8)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1318",
    "data-name": "Group 1318",
    transform: "translate(0 296.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1317",
    "data-name": "Group 1317"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3854",
    "data-name": "Path 3854",
    d: "M396.479,550.526H1057.69c31.185,0,31.185-48.726,0-48.726H396.479c-31.672,0-31.672,48.726,0,48.726Z",
    transform: "translate(-372.725 -501.8)",
    fill: "#f2f2f2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1338",
    "data-name": "Group 1338",
    transform: "translate(142.28 1356.044)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1321",
    "data-name": "Group 1321",
    transform: "translate(129.124 296.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1320",
    "data-name": "Group 1320"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3855",
    "data-name": "Path 3855",
    d: "M744.767,587.1H422.688c-31.185,0-31.185,48.726,0,48.726H744.767c31.672,0,31.672-48.726,0-48.726Z",
    transform: "translate(-399.3 -587.1)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1323",
    "data-name": "Group 1323",
    transform: "translate(554.014 296.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1322",
    "data-name": "Group 1322"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3856",
    "data-name": "Path 3856",
    d: "M884.591,587.1h-374.7c-31.185,0-31.185,48.726,0,48.726h374.7c31.672,0,31.672-48.726,0-48.726Z",
    transform: "translate(-486.5 -587.1)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1325",
    "data-name": "Group 1325",
    transform: "translate(0 197.827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1324",
    "data-name": "Group 1324"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3857",
    "data-name": "Path 3857",
    d: "M630.073,566.8H396.188c-31.185,0-31.185,48.726,0,48.726H630.073c31.185,0,31.185-48.726,0-48.726Z",
    transform: "translate(-372.8 -566.8)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1327",
    "data-name": "Group 1327",
    transform: "translate(338.158 197.827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1326",
    "data-name": "Group 1326"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3858",
    "data-name": "Path 3858",
    d: "M818.852,566.8H465.588c-31.185,0-31.185,48.726,0,48.726H818.852c31.672,0,31.672-48.726,0-48.726Z",
    transform: "translate(-442.2 -566.8)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1329",
    "data-name": "Group 1329",
    transform: "translate(793.746 197.827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1328",
    "data-name": "Group 1328"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3859",
    "data-name": "Path 3859",
    d: "M694.06,566.8H559.088c-31.185,0-31.185,48.726,0,48.726H694.06c31.672,0,31.672-48.726,0-48.726Z",
    transform: "translate(-535.7 -566.8)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1331",
    "data-name": "Group 1331",
    transform: "translate(0 98.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1330",
    "data-name": "Group 1330"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3860",
    "data-name": "Path 3860",
    d: "M855.674,546.5H396.188c-31.185,0-31.185,48.726,0,48.726H855.674c31.672,0,31.672-48.726,0-48.726Z",
    transform: "translate(-372.8 -546.5)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1333",
    "data-name": "Group 1333",
    transform: "translate(561.81 98.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1332",
    "data-name": "Group 1332"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3861",
    "data-name": "Path 3861",
    d: "M694.7,546.5H511.488c-31.185,0-31.185,48.726,0,48.726H694.7c31.185,0,31.185-48.726,0-48.726Z",
    transform: "translate(-488.1 -546.5)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1335",
    "data-name": "Group 1335",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1334",
    "data-name": "Group 1334"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3862",
    "data-name": "Path 3862",
    d: "M561.857,526.2H396.188c-31.185,0-31.185,48.726,0,48.726H561.857c31.185,0,31.185-48.726,0-48.726Z",
    transform: "translate(-372.8 -526.2)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1337",
    "data-name": "Group 1337",
    transform: "translate(267.506)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1336",
    "data-name": "Group 1336"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3863",
    "data-name": "Path 3863",
    d: "M1112.3,526.2H451.088c-31.185,0-31.185,48.726,0,48.726H1112.3c31.672,0,31.672-48.726,0-48.726Z",
    transform: "translate(-427.7 -526.2)",
    fill: "#f2f2f2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1357",
    "data-name": "Group 1357",
    transform: "translate(142.28 1897.876)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1340",
    "data-name": "Group 1340",
    transform: "translate(129.124 296.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1339",
    "data-name": "Group 1339"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3864",
    "data-name": "Path 3864",
    d: "M744.767,698.3H422.688c-31.185,0-31.185,48.726,0,48.726H744.767c31.672,0,31.672-48.726,0-48.726Z",
    transform: "translate(-399.3 -698.3)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1342",
    "data-name": "Group 1342",
    transform: "translate(554.014 296.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1341",
    "data-name": "Group 1341"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3865",
    "data-name": "Path 3865",
    d: "M884.591,698.3h-374.7c-31.185,0-31.185,48.726,0,48.726h374.7c31.672,0,31.672-48.726,0-48.726Z",
    transform: "translate(-486.5 -698.3)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1344",
    "data-name": "Group 1344",
    transform: "translate(0 197.827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1343",
    "data-name": "Group 1343"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3866",
    "data-name": "Path 3866",
    d: "M630.073,678H396.188c-31.185,0-31.185,48.726,0,48.726H630.073c31.185,0,31.185-48.726,0-48.726Z",
    transform: "translate(-372.8 -678)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1346",
    "data-name": "Group 1346",
    transform: "translate(338.158 197.827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1345",
    "data-name": "Group 1345"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3867",
    "data-name": "Path 3867",
    d: "M818.852,678H465.588c-31.185,0-31.185,48.726,0,48.726H818.852c31.672,0,31.672-48.726,0-48.726Z",
    transform: "translate(-442.2 -678)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1348",
    "data-name": "Group 1348",
    transform: "translate(793.746 197.827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1347",
    "data-name": "Group 1347"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3868",
    "data-name": "Path 3868",
    d: "M694.06,678H559.088c-31.185,0-31.185,48.726,0,48.726H694.06c31.672,0,31.672-48.726,0-48.726Z",
    transform: "translate(-535.7 -678)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1350",
    "data-name": "Group 1350",
    transform: "translate(0 98.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1349",
    "data-name": "Group 1349"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3869",
    "data-name": "Path 3869",
    d: "M855.674,657.7H396.188c-31.185,0-31.185,48.726,0,48.726H855.674c31.672,0,31.672-48.726,0-48.726Z",
    transform: "translate(-372.8 -657.7)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1352",
    "data-name": "Group 1352",
    transform: "translate(561.81 98.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1351",
    "data-name": "Group 1351"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3870",
    "data-name": "Path 3870",
    d: "M694.7,657.7H511.488c-31.185,0-31.185,48.726,0,48.726H694.7c31.185,0,31.185-48.726,0-48.726Z",
    transform: "translate(-488.1 -657.7)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1354",
    "data-name": "Group 1354",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1353",
    "data-name": "Group 1353"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3871",
    "data-name": "Path 3871",
    d: "M561.857,637.4H396.188c-31.185,0-31.185,48.726,0,48.726H561.857c31.185,0,31.185-48.726,0-48.726Z",
    transform: "translate(-372.8 -637.4)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1356",
    "data-name": "Group 1356",
    transform: "translate(267.506)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1355",
    "data-name": "Group 1355"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3872",
    "data-name": "Path 3872",
    d: "M1112.3,637.4H451.088c-31.185,0-31.185,48.726,0,48.726H1112.3c31.672,0,31.672-48.726,0-48.726Z",
    transform: "translate(-427.7 -637.4)",
    fill: "#f2f2f2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1376",
    "data-name": "Group 1376",
    transform: "translate(142.28 2347.617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1359",
    "data-name": "Group 1359",
    transform: "translate(129.124 296.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1358",
    "data-name": "Group 1358"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3873",
    "data-name": "Path 3873",
    d: "M744.767,790.6H422.688c-31.185,0-31.185,48.726,0,48.726H744.767c31.672,0,31.672-48.726,0-48.726Z",
    transform: "translate(-399.3 -790.6)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1361",
    "data-name": "Group 1361",
    transform: "translate(554.014 296.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1360",
    "data-name": "Group 1360"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3874",
    "data-name": "Path 3874",
    d: "M884.591,790.6h-374.7c-31.185,0-31.185,48.726,0,48.726h374.7c31.672,0,31.672-48.726,0-48.726Z",
    transform: "translate(-486.5 -790.6)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1363",
    "data-name": "Group 1363",
    transform: "translate(0 197.827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1362",
    "data-name": "Group 1362"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3875",
    "data-name": "Path 3875",
    d: "M630.073,770.3H396.188c-31.185,0-31.185,48.726,0,48.726H630.073c31.185,0,31.185-48.726,0-48.726Z",
    transform: "translate(-372.8 -770.3)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1365",
    "data-name": "Group 1365",
    transform: "translate(338.158 197.827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1364",
    "data-name": "Group 1364"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3876",
    "data-name": "Path 3876",
    d: "M818.852,770.3H465.588c-31.185,0-31.185,48.726,0,48.726H818.852c31.672,0,31.672-48.726,0-48.726Z",
    transform: "translate(-442.2 -770.3)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1367",
    "data-name": "Group 1367",
    transform: "translate(793.746 197.827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1366",
    "data-name": "Group 1366"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3877",
    "data-name": "Path 3877",
    d: "M694.06,770.3H559.088c-31.185,0-31.185,48.726,0,48.726H694.06c31.672,0,31.672-48.726,0-48.726Z",
    transform: "translate(-535.7 -770.3)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1369",
    "data-name": "Group 1369",
    transform: "translate(0 98.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1368",
    "data-name": "Group 1368"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3878",
    "data-name": "Path 3878",
    d: "M855.674,750H396.188c-31.185,0-31.185,48.726,0,48.726H855.674c31.672,0,31.672-48.726,0-48.726Z",
    transform: "translate(-372.8 -750)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1371",
    "data-name": "Group 1371",
    transform: "translate(561.81 98.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1370",
    "data-name": "Group 1370"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3879",
    "data-name": "Path 3879",
    d: "M694.7,750H511.488c-31.185,0-31.185,48.726,0,48.726H694.7c31.185,0,31.185-48.726,0-48.726Z",
    transform: "translate(-488.1 -750)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1373",
    "data-name": "Group 1373",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1372",
    "data-name": "Group 1372"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3880",
    "data-name": "Path 3880",
    d: "M561.857,729.7H396.188c-31.185,0-31.185,48.726,0,48.726H561.857c31.185,0,31.185-48.726,0-48.726Z",
    transform: "translate(-372.8 -729.7)",
    fill: "#f2f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1375",
    "data-name": "Group 1375",
    transform: "translate(267.506 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1374",
    "data-name": "Group 1374"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3881",
    "data-name": "Path 3881",
    d: "M1112.3,729.7H451.088c-31.185,0-31.185,48.726,0,48.726H1112.3c31.672,0,31.672-48.726,0-48.726Z",
    transform: "translate(-427.7 -729.7)",
    fill: "#f2f2f2"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1444",
    "data-name": "Group 1444",
    transform: "translate(1584.766 1465.019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1386",
    "data-name": "Group 1386"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1383",
    "data-name": "Group 1383",
    transform: "translate(202.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3882",
    "data-name": "Path 3882",
    d: "M3655.911,523.369c0-34.6-27.287-62.369-59.933-62.369H619.8c-32.646,0-57.5,27.774-57.5,62.369V2330.615c0,34.6,24.363,67.242,57.5,67.242H3595.978c32.646,0,59.933-32.646,59.933-67.242Z",
    transform: "translate(-539.399 -461)",
    fill: "#2b2f47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3883",
    "data-name": "Path 3883",
    d: "M3380.45,550.084c0-31.672-29.723-57.984-59.446-57.984H646.437c-29.236,0-52.137,26.312-52.137,57.984V2190.2c0,31.672,22.414,55.06,52.137,55.06H3321c29.236,0,59.446-23.388,59.446-55.06Z",
    transform: "translate(-415.476 -340.562)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3884",
    "data-name": "Path 3884",
    d: "M593.7,812.5V949.42c0,31.672,25.338,57.5,54.573,57.5H3322.841c29.235,0,54.573-26.312,54.573-57.5V812.5Z",
    transform: "translate(-417.799 900.218)",
    fill: "#afcedb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3885",
    "data-name": "Path 3885",
    d: "M3377.514,662.215V550.633c0-31.672-25.337-59.933-54.573-59.933H648.373c-29.236,0-54.573,28.261-54.573,59.933V662.215Z",
    transform: "translate(-417.412 -345.984)",
    fill: "#afcedb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1379",
    "data-name": "Group 1379",
    transform: "translate(158.339 124.869)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1378",
    "data-name": "Group 1378"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3886",
    "data-name": "Path 3886",
    d: "M3406.477,559.585c-5.36-82.347-86.732-72.6-144.716-72.6H679.772c-19,0-34.6-.487-52.624,7.8-34.6,16.567-36.057,55.548-36.057,88.681V2116.38c0,55.06-14.618,153,68.216,153H3330.951c42.879,0,76.012-32.646,76.012-75.038V859.738q-.73-149.833-.487-300.152c0-19-29.236-19-29.236,0V2199.214c0,55.06-93.553,40.93-128.149,40.93H672.95c-26.312,0-53.112-6.334-53.112-40.93V559.585c0-38.981,29.236-43.366,57.5-43.366H3257.862c38.494,0,114.993-13.156,118.891,43.366C3378.7,578.588,3407.938,578.588,3406.477,559.585Z",
    transform: "translate(-590.096 -486.627)",
    fill: "#003054"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1380",
    "data-name": "Group 1380",
    transform: "translate(0 1844.765)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3887",
    "data-name": "Path 3887",
    d: "M759.325,859.578A19.759,19.759,0,0,0,739.348,839.6H577.578A19.759,19.759,0,0,0,557.6,859.578v70.165a19.759,19.759,0,0,0,19.978,19.978h161.77a19.759,19.759,0,0,0,19.978-19.978Z",
    transform: "translate(-557.6 -839.6)",
    fill: "#404560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3888",
    "data-name": "Path 3888",
    d: "M811.125,859.578A19.76,19.76,0,0,0,791.148,839.6H629.377A19.759,19.759,0,0,0,609.4,859.578v70.165a19.759,19.759,0,0,0,19.978,19.978h161.77a19.759,19.759,0,0,0,19.978-19.978Z",
    transform: "translate(-356.999 -839.6)",
    fill: "#404560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3889",
    "data-name": "Path 3889",
    d: "M862.925,859.578A19.76,19.76,0,0,0,842.948,839.6H681.177A19.759,19.759,0,0,0,661.2,859.578v70.165a19.759,19.759,0,0,0,19.978,19.978h161.77a19.759,19.759,0,0,0,19.978-19.978Z",
    transform: "translate(-156.399 -839.6)",
    fill: "#404560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3890",
    "data-name": "Path 3890",
    d: "M913.825,859.578A19.759,19.759,0,0,0,893.848,839.6H732.077A19.76,19.76,0,0,0,712.1,859.578v70.165a19.759,19.759,0,0,0,19.978,19.978h161.77a19.759,19.759,0,0,0,19.978-19.978Z",
    transform: "translate(40.716 -839.6)",
    fill: "#404560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3891",
    "data-name": "Path 3891",
    d: "M965.625,859.578A19.759,19.759,0,0,0,945.647,839.6H783.877A19.759,19.759,0,0,0,763.9,859.578v70.165a19.759,19.759,0,0,0,19.977,19.978h161.77a19.759,19.759,0,0,0,19.978-19.978Z",
    transform: "translate(241.317 -839.6)",
    fill: "#404560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3892",
    "data-name": "Path 3892",
    d: "M1016.525,859.578A19.759,19.759,0,0,0,996.548,839.6H834.777A19.76,19.76,0,0,0,814.8,859.578v70.165a19.759,19.759,0,0,0,19.978,19.978h161.77a19.759,19.759,0,0,0,19.978-19.978Z",
    transform: "translate(438.432 -839.6)",
    fill: "#404560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3893",
    "data-name": "Path 3893",
    d: "M1068.325,859.578a19.759,19.759,0,0,0-19.978-19.978H886.578A19.759,19.759,0,0,0,866.6,859.578v70.165a19.759,19.759,0,0,0,19.978,19.978h161.77a19.759,19.759,0,0,0,19.978-19.978Z",
    transform: "translate(639.032 -839.6)",
    fill: "#404560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3894",
    "data-name": "Path 3894",
    d: "M1120.125,859.578a19.759,19.759,0,0,0-19.978-19.978H938.377A19.759,19.759,0,0,0,918.4,859.578v70.165a19.759,19.759,0,0,0,19.978,19.978h161.77a19.759,19.759,0,0,0,19.978-19.978Z",
    transform: "translate(839.633 -839.6)",
    fill: "#404560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3895",
    "data-name": "Path 3895",
    d: "M1171.025,859.578a19.759,19.759,0,0,0-19.978-19.978H989.277A19.759,19.759,0,0,0,969.3,859.578v70.165a19.759,19.759,0,0,0,19.978,19.978h161.77a19.759,19.759,0,0,0,19.978-19.978Z",
    transform: "translate(1036.748 -839.6)",
    fill: "#404560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3896",
    "data-name": "Path 3896",
    d: "M1221.825,859.578a19.759,19.759,0,0,0-19.978-19.978h-161.77a19.759,19.759,0,0,0-19.978,19.978v70.165a19.759,19.759,0,0,0,19.978,19.978h161.77a19.759,19.759,0,0,0,19.978-19.978Z",
    transform: "translate(1233.476 -839.6)",
    fill: "#404560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3897",
    "data-name": "Path 3897",
    d: "M1273.625,859.578a19.76,19.76,0,0,0-19.978-19.978H1091.877a19.759,19.759,0,0,0-19.978,19.978v70.165a19.76,19.76,0,0,0,19.978,19.978h161.77a19.759,19.759,0,0,0,19.978-19.978V859.578Z",
    transform: "translate(1434.076 -839.6)",
    fill: "#404560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3898",
    "data-name": "Path 3898",
    d: "M1325.425,859.578a19.76,19.76,0,0,0-19.978-19.978h-161.77a19.759,19.759,0,0,0-19.978,19.978v70.165a19.76,19.76,0,0,0,19.978,19.978h161.77a19.759,19.759,0,0,0,19.978-19.978Z",
    transform: "translate(1634.677 -839.6)",
    fill: "#404560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3899",
    "data-name": "Path 3899",
    d: "M1376.325,859.578a19.76,19.76,0,0,0-19.978-19.978h-161.77a19.759,19.759,0,0,0-19.978,19.978v70.165a19.76,19.76,0,0,0,19.978,19.978h161.77a19.759,19.759,0,0,0,19.978-19.978Z",
    transform: "translate(1831.792 -839.6)",
    fill: "#404560"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3900",
    "data-name": "Path 3900",
    d: "M1406.648,492.765a20.589,20.589,0,0,0-20.465-20.465H839.965A20.588,20.588,0,0,0,819.5,492.765h0a20.589,20.589,0,0,0,20.465,20.465h546.218a20.589,20.589,0,0,0,20.465-20.465Z",
    transform: "translate(456.633 -417.24)",
    fill: "#404560"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1382",
    "data-name": "Group 1382",
    transform: "translate(237.783 193.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1381",
    "data-name": "Group 1381"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_452",
    "data-name": "Ellipse 452",
    cx: 42.392,
    cy: 38.494,
    rx: 42.392,
    ry: 38.494,
    transform: "translate(282.611)",
    fill: "#dcedef"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_453",
    "data-name": "Ellipse 453",
    cx: 42.392,
    cy: 38.494,
    rx: 42.392,
    ry: 38.494,
    transform: "translate(147.64)",
    fill: "#dcedef"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_454",
    "data-name": "Ellipse 454",
    cx: 42.392,
    cy: 38.494,
    rx: 42.392,
    ry: 38.494,
    fill: "#dcedef"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3901",
    "data-name": "Path 3901",
    d: "M2286.33,534.546c0-18.029-16.08-32.646-35.57-32.646H735.87c-19.49,0-35.57,14.618-35.57,32.646h0c0,18.029,16.08,32.646,35.57,32.646H2250.76c19.49,0,35.57-14.618,35.57-32.646Z",
    transform: "translate(-242.763 -496.54)",
    fill: "#dcedef"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1384",
    "data-name": "Group 1384",
    transform: "translate(1046.634 783.026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3902",
    "data-name": "Path 3902",
    d: "M730.8,621.7Z",
    transform: "translate(-730.8 -621.7)",
    fill: "#dfedee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1385",
    "data-name": "Group 1385",
    transform: "translate(0 1888.618)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1008_",
    d: "M4066.173,857.9H516c70.653,80.4,166.155,125.713,266.043,125.713H3800.13c99.4,0,195.391-45.315,266.043-125.713Z",
    transform: "translate(-516 -812.585)",
    fill: "#404560"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1007_",
    width: 3550.174,
    height: 69.678,
    fill: "#2b2f47"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1405",
    "data-name": "Group 1405",
    transform: "translate(1697.612 444.868)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1388",
    "data-name": "Group 1388",
    transform: "translate(654.024)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1387",
    "data-name": "Group 1387"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3903",
    "data-name": "Path 3903",
    d: "M1022.379,601.026h441.457c31.185,0,31.185-48.726,0-48.726H1022.379c-31.672,0-31.672,48.726,0,48.726Z",
    transform: "translate(-998.625 -552.3)",
    fill: "#d4dadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1390",
    "data-name": "Group 1390",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1389",
    "data-name": "Group 1389"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3904",
    "data-name": "Path 3904",
    d: "M887.788,601.026h514.059c31.185,0,31.185-48.726,0-48.726H887.788c-31.185,0-31.185,48.726,0,48.726Z",
    transform: "translate(-864.4 -552.3)",
    fill: "#d4dadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1392",
    "data-name": "Group 1392",
    transform: "translate(952.593 98.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1391",
    "data-name": "Group 1391"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3905",
    "data-name": "Path 3905",
    d: "M1083.288,621.326h320.617c31.185,0,31.185-48.726,0-48.726H1083.288c-31.184,0-31.184,48.726,0,48.726Z",
    transform: "translate(-1059.9 -572.6)",
    fill: "#d4dadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1394",
    "data-name": "Group 1394",
    transform: "translate(325.002 98.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1393",
    "data-name": "Group 1393"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3906",
    "data-name": "Path 3906",
    d: "M954.489,621.326h484.336c31.185,0,31.185-48.726,0-48.726H954.489c-31.185,0-31.185,48.726,0,48.726Z",
    transform: "translate(-931.1 -572.6)",
    fill: "#d4dadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1396",
    "data-name": "Group 1396",
    transform: "translate(0 98.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1395",
    "data-name": "Group 1395"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3907",
    "data-name": "Path 3907",
    d: "M887.788,621.326H1072.46c31.185,0,31.185-48.726,0-48.726H887.788c-31.185,0-31.185,48.726,0,48.726Z",
    transform: "translate(-864.4 -572.6)",
    fill: "#d4dadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1398",
    "data-name": "Group 1398",
    transform: "translate(642.818 197.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1397",
    "data-name": "Group 1397"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3908",
    "data-name": "Path 3908",
    d: "M1020.079,641.626h630.027c31.185,0,31.185-48.726,0-48.726H1020.079c-31.672,0-31.672,48.726,0,48.726Z",
    transform: "translate(-996.325 -592.9)",
    fill: "#d4dadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1400",
    "data-name": "Group 1400",
    transform: "translate(251.548 197.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1399",
    "data-name": "Group 1399"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3909",
    "data-name": "Path 3909",
    d: "M939.779,641.626h250.939c31.185,0,31.185-48.726,0-48.726H939.779c-31.672,0-31.672,48.726,0,48.726Z",
    transform: "translate(-916.025 -592.9)",
    fill: "#d4dadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1402",
    "data-name": "Group 1402",
    transform: "translate(1045.781 296.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1401",
    "data-name": "Group 1401"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3910",
    "data-name": "Path 3910",
    d: "M1102.779,661.926h227.063c31.185,0,31.185-48.726,0-48.726H1102.779c-31.672,0-31.672,48.726,0,48.726Z",
    transform: "translate(-1079.025 -613.2)",
    fill: "#d4dadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1404",
    "data-name": "Group 1404",
    transform: "translate(0 296.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1403",
    "data-name": "Group 1403"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3911",
    "data-name": "Path 3911",
    d: "M887.789,661.926h906.3c31.185,0,31.185-48.726,0-48.726h-906.3c-31.184,0-31.184,48.726,0,48.726Z",
    transform: "translate(-864.4 -613.2)",
    fill: "#d4dadc"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1424",
    "data-name": "Group 1424",
    transform: "translate(1697.612 859.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1407",
    "data-name": "Group 1407",
    transform: "translate(654.024)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1406",
    "data-name": "Group 1406"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3912",
    "data-name": "Path 3912",
    d: "M1022.379,686.026h441.457c31.185,0,31.185-48.726,0-48.726H1022.379c-31.672,0-31.672,48.726,0,48.726Z",
    transform: "translate(-998.625 -637.3)",
    fill: "#d4dadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1409",
    "data-name": "Group 1409",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1408",
    "data-name": "Group 1408"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3913",
    "data-name": "Path 3913",
    d: "M887.788,686.026h514.059c31.185,0,31.185-48.726,0-48.726H887.788c-31.185,0-31.185,48.726,0,48.726Z",
    transform: "translate(-864.4 -637.3)",
    fill: "#d4dadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1411",
    "data-name": "Group 1411",
    transform: "translate(952.593 98.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1410",
    "data-name": "Group 1410"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3914",
    "data-name": "Path 3914",
    d: "M1083.288,706.326h320.617c31.185,0,31.185-48.726,0-48.726H1083.288c-31.184,0-31.184,48.726,0,48.726Z",
    transform: "translate(-1059.9 -657.6)",
    fill: "#d4dadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1413",
    "data-name": "Group 1413",
    transform: "translate(325.002 98.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1412",
    "data-name": "Group 1412"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3915",
    "data-name": "Path 3915",
    d: "M954.489,706.326h484.336c31.185,0,31.185-48.726,0-48.726H954.489c-31.185,0-31.185,48.726,0,48.726Z",
    transform: "translate(-931.1 -657.6)",
    fill: "#d4dadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1415",
    "data-name": "Group 1415",
    transform: "translate(0 98.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1414",
    "data-name": "Group 1414"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3916",
    "data-name": "Path 3916",
    d: "M887.788,706.326H1072.46c31.185,0,31.185-48.726,0-48.726H887.788c-31.185,0-31.185,48.726,0,48.726Z",
    transform: "translate(-864.4 -657.6)",
    fill: "#d4dadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1417",
    "data-name": "Group 1417",
    transform: "translate(642.818 197.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1416",
    "data-name": "Group 1416"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3917",
    "data-name": "Path 3917",
    d: "M1020.079,726.626h630.027c31.185,0,31.185-48.726,0-48.726H1020.079c-31.672,0-31.672,48.726,0,48.726Z",
    transform: "translate(-996.325 -677.9)",
    fill: "#d4dadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1419",
    "data-name": "Group 1419",
    transform: "translate(251.548 197.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1418",
    "data-name": "Group 1418"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3918",
    "data-name": "Path 3918",
    d: "M939.779,726.626h250.939c31.185,0,31.185-48.726,0-48.726H939.779c-31.672,0-31.672,48.726,0,48.726Z",
    transform: "translate(-916.025 -677.9)",
    fill: "#d4dadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1421",
    "data-name": "Group 1421",
    transform: "translate(1045.781 296.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1420",
    "data-name": "Group 1420"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3919",
    "data-name": "Path 3919",
    d: "M1102.779,746.926h227.063c31.185,0,31.185-48.726,0-48.726H1102.779c-31.672,0-31.672,48.726,0,48.726Z",
    transform: "translate(-1079.025 -698.2)",
    fill: "#d4dadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1423",
    "data-name": "Group 1423",
    transform: "translate(0 296.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1422",
    "data-name": "Group 1422"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3920",
    "data-name": "Path 3920",
    d: "M887.789,746.926h906.3c31.185,0,31.185-48.726,0-48.726h-906.3c-31.184,0-31.184,48.726,0,48.726Z",
    transform: "translate(-864.4 -698.2)",
    fill: "#d4dadc"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1443",
    "data-name": "Group 1443",
    transform: "translate(1697.613 1258.592)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1426",
    "data-name": "Group 1426",
    transform: "translate(177.363 296.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1425",
    "data-name": "Group 1425"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3921",
    "data-name": "Path 3921",
    d: "M1365.646,780.2H924.188c-31.185,0-31.185,48.726,0,48.726h441.457c31.672,0,31.672-48.726,0-48.726Z",
    transform: "translate(-900.8 -780.2)",
    fill: "#d4dadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1428",
    "data-name": "Group 1428",
    transform: "translate(759.15 296.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1427",
    "data-name": "Group 1427"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3922",
    "data-name": "Path 3922",
    d: "M1557.647,780.2H1043.588c-31.185,0-31.185,48.726,0,48.726h514.059c31.185,0,31.185-48.726,0-48.726Z",
    transform: "translate(-1020.2 -780.2)",
    fill: "#d4dadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1430",
    "data-name": "Group 1430",
    transform: "translate(0 197.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1429",
    "data-name": "Group 1429"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3923",
    "data-name": "Path 3923",
    d: "M1208.405,759.9H887.788c-31.185,0-31.185,48.726,0,48.726h320.617c31.185,0,31.185-48.726,0-48.726Z",
    transform: "translate(-864.4 -759.9)",
    fill: "#d4dadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1432",
    "data-name": "Group 1432",
    transform: "translate(463.871 197.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1431",
    "data-name": "Group 1431"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3924",
    "data-name": "Path 3924",
    d: "M1467.325,759.9H982.988c-31.185,0-31.185,48.726,0,48.726h484.336c31.184,0,31.184-48.726,0-48.726Z",
    transform: "translate(-959.6 -759.9)",
    fill: "#d4dadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1434",
    "data-name": "Group 1434",
    transform: "translate(1088.538 197.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1433",
    "data-name": "Group 1433"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3925",
    "data-name": "Path 3925",
    d: "M1295.86,759.9H1111.188c-31.185,0-31.185,48.726,0,48.726H1295.86c31.185,0,31.185-48.726,0-48.726Z",
    transform: "translate(-1087.8 -759.9)",
    fill: "#d4dadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1436",
    "data-name": "Group 1436",
    transform: "translate(0 98.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1435",
    "data-name": "Group 1435"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3926",
    "data-name": "Path 3926",
    d: "M1517.815,739.6H887.788c-31.185,0-31.185,48.726,0,48.726h630.027c31.672,0,31.672-48.726,0-48.726Z",
    transform: "translate(-864.4 -739.6)",
    fill: "#d4dadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1438",
    "data-name": "Group 1438",
    transform: "translate(770.357 98.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1437",
    "data-name": "Group 1437"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3927",
    "data-name": "Path 3927",
    d: "M1296.827,739.6H1045.888c-31.185,0-31.185,48.726,0,48.726h250.939c31.672,0,31.672-48.726,0-48.726Z",
    transform: "translate(-1022.5 -739.6)",
    fill: "#d4dadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1440",
    "data-name": "Group 1440"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1439",
    "data-name": "Group 1439"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3928",
    "data-name": "Path 3928",
    d: "M1114.851,719.3H887.788c-31.185,0-31.185,48.726,0,48.726h227.063c31.672,0,31.672-48.726,0-48.726Z",
    transform: "translate(-864.4 -719.3)",
    fill: "#d4dadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1442",
    "data-name": "Group 1442",
    transform: "translate(366.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1441",
    "data-name": "Group 1441"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3929",
    "data-name": "Path 3929",
    d: "M1869.392,719.3h-906.3c-31.185,0-31.185,48.726,0,48.726h906.3c31.185,0,31.185-48.726,0-48.726Z",
    transform: "translate(-939.7 -719.3)",
    fill: "#d4dadc"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_774",
    "data-name": "Rectangle 774",
    width: 1110,
    height: 1189,
    transform: "translate(487.74 428.733)",
    fill: "#eaf4f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1447",
    "data-name": "Group 1447",
    transform: "translate(608.785 1113.704)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3930",
    "data-name": "Path 3930",
    d: "M725.973,614.988c0-118.891-97.452-226.088-205.136-226.088S315.7,496.1,315.7,614.988c0,70.166,75.038,210.009,75.038,231.448,0,76.012,57.984,78.936,130.1,78.936,71.627,0,130.1-2.924,130.1-78.936C650.935,825.485,725.973,685.641,725.973,614.988Z",
    transform: "translate(-315.7 -388.9)",
    fill: "#fdd451"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3931",
    "data-name": "Path 3931",
    d: "M341.6,611.166c0,45.8,37.519,87.22,78.936,87.22s78.936-41.417,78.936-87.22c0-27.286-28.748-80.885-28.748-89.168,0-29.236-22.414-30.7-50.188-30.7s-50.188.975-50.188,30.7C370.348,529.793,341.6,583.879,341.6,611.166Z",
    transform: "translate(-215.399 7.654)",
    fill: "#becacc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3932",
    "data-name": "Path 3932",
    d: "M459.444,540.413c-3.9-9.258-6.334-16.08-6.334-18.516,0-29.236-22.414-30.7-50.188-30.7s-50.188.975-50.188,30.7c0,2.436-2.924,9.258-6.334,18.516Z",
    transform: "translate(-196.811 7.267)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1445",
    "data-name": "Group 1445",
    transform: "translate(110.608 518.444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3933",
    "data-name": "Path 3933",
    d: "M531.842,514.79a19.548,19.548,0,0,0-19.49-19.49H357.89a19.547,19.547,0,0,0-19.49,19.49v.487a19.548,19.548,0,0,0,19.49,19.49H512.352a19.548,19.548,0,0,0,19.49-19.49Z",
    transform: "translate(-338.4 -495.3)",
    fill: "#d1dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3934",
    "data-name": "Path 3934",
    d: "M531.842,531.09a19.548,19.548,0,0,0-19.49-19.49H357.89a19.548,19.548,0,0,0-19.49,19.49v.487a19.548,19.548,0,0,0,19.49,19.49H512.352a19.548,19.548,0,0,0,19.49-19.49Z",
    transform: "translate(-338.4 -432.177)",
    fill: "#d1dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3935",
    "data-name": "Path 3935",
    d: "M531.842,521.99a19.548,19.548,0,0,0-19.49-19.49H357.89a19.547,19.547,0,0,0-19.49,19.49v.487a19.548,19.548,0,0,0,19.49,19.49H512.352a19.548,19.548,0,0,0,19.49-19.49Z",
    transform: "translate(-338.4 -467.417)",
    fill: "#becacc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1446",
    "data-name": "Group 1446",
    transform: "translate(117.362 199.289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3936",
    "data-name": "Path 3936",
    d: "M378.188,746.031S366.494,429.8,407.424,429.8c35.083,0,99.4,94.528-52.624,94.528",
    transform: "translate(-281.643 -429.8)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3937",
    "data-name": "Path 3937",
    d: "M412.943,746.031S424.637,429.8,383.707,429.8c-35.083,0-99.4,94.528,52.624,94.528",
    transform: "translate(-339.786 -429.8)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1450",
    "data-name": "Group 1450",
    transform: "translate(4356.787 112.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3938",
    "data-name": "Path 3938",
    d: "M1495.172,409.588c0-118.891-97.452-226.088-205.136-226.088S1084.9,290.7,1084.9,409.588c0,70.165,75.038,210.009,75.038,231.448,0,76.012,57.984,78.936,130.1,78.936,71.627,0,130.1-2.924,130.1-78.936C1420.134,620.085,1495.172,479.754,1495.172,409.588Z",
    transform: "translate(-1084.9 -183.5)",
    fill: "#ffd878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3939",
    "data-name": "Path 3939",
    d: "M1110.8,405.766c0,45.8,37.519,87.219,78.936,87.219s78.936-41.417,78.936-87.219c0-27.287-28.749-80.885-28.749-89.168,0-29.236-22.414-30.7-50.188-30.7s-50.188.974-50.188,30.7C1140.036,324.393,1110.8,378.479,1110.8,405.766Z",
    transform: "translate(-984.599 213.054)",
    fill: "#becacc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3940",
    "data-name": "Path 3940",
    d: "M1228.645,335.013c-3.9-9.258-6.335-16.079-6.335-18.516,0-29.236-22.414-30.7-50.188-30.7s-50.188.974-50.188,30.7c0,2.436-2.923,9.258-6.334,18.516Z",
    transform: "translate(-966.012 212.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1448",
    "data-name": "Group 1448",
    transform: "translate(111.095 518.444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3941",
    "data-name": "Path 3941",
    d: "M1301.142,309.39a19.547,19.547,0,0,0-19.49-19.49H1127.19a19.548,19.548,0,0,0-19.491,19.49v.487a19.548,19.548,0,0,0,19.491,19.49h154.461a19.548,19.548,0,0,0,19.49-19.49Z",
    transform: "translate(-1107.7 -289.9)",
    fill: "#d1dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3942",
    "data-name": "Path 3942",
    d: "M1301.142,325.69a19.548,19.548,0,0,0-19.49-19.49H1127.19a19.548,19.548,0,0,0-19.491,19.49v.487a19.548,19.548,0,0,0,19.491,19.49h154.461a19.548,19.548,0,0,0,19.49-19.49Z",
    transform: "translate(-1107.7 -226.777)",
    fill: "#d1dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3943",
    "data-name": "Path 3943",
    d: "M1301.142,316.59a19.547,19.547,0,0,0-19.49-19.49H1127.19a19.548,19.548,0,0,0-19.491,19.49v.487a19.548,19.548,0,0,0,19.491,19.49h154.461a19.548,19.548,0,0,0,19.49-19.49Z",
    transform: "translate(-1107.7 -262.017)",
    fill: "#becacc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1449",
    "data-name": "Group 1449",
    transform: "translate(117.849 199.289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3944",
    "data-name": "Path 3944",
    d: "M1147.488,540.631S1135.794,224.4,1176.724,224.4c35.083,0,99.4,94.528-52.625,94.528",
    transform: "translate(-1050.943 -224.4)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3945",
    "data-name": "Path 3945",
    d: "M1182.242,540.631S1193.937,224.4,1153.007,224.4c-35.083,0-99.4,94.528,52.624,94.528",
    transform: "translate(-1109.086 -224.4)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1461",
    "data-name": "Group 1461",
    transform: "translate(1781.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3961",
    "data-name": "Path 3961",
    d: "M1214.7,401.6l-12.668,94.041L717.207,525.364c-76.012,0-117.917,61.882-114.993,134,2.924,58.471,45.315,723.581,32.646,723.581H770.318v-627.1c0-17.541,17.054-32.159,35.57-32.159l581.788-25.825c107.684,0,196.366-57.5,196.366-159.821V455.2Z",
    transform: "translate(-379.291 773.987)",
    fill: "#896060"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1453",
    "data-name": "Group 1453",
    transform: "translate(655.122 1.713)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3962",
    "data-name": "Path 3962",
    d: "M888.556,161.239c73.576-6.334,141.305,42.392,155.436,114.993,11.207,56.035-12.668,117.917-54.573,237.783,0,0-169.566-43.853-170.054-43.853-14.131-4.873-35.57-40.93-45.315-52.624-22.9-26.312-55.06-46.777-73.576-76.5-31.185-50.188,31.672-118.4,71.14-144.229C805.722,173.908,848.6,164.65,888.556,161.239Z",
    transform: "translate(-685.856 -160.687)",
    fill: "#2b2f47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3963",
    "data-name": "Path 3963",
    d: "M906.791,561.038s102.324-36.544,96.965-72.114C990.112,395.369,827.367,206.8,827.367,206.8L711.4,290.609Z",
    transform: "translate(-611.024 17.892)",
    fill: "#896060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3964",
    "data-name": "Path 3964",
    d: "M702.494,203.628a255,255,0,0,0-11.694,60.42v6.334c.975,30.21,23.388,49.7,25.337,78.449.975,17.541-10.72,35.57-5.847,53.111,5.847,20.465,29.723,6.822,32.646,11.694l44.341,72.115a33.352,33.352,0,0,0,48.239,9.258l71.627-50.188c33.134-24.363,41.9-70.165,19.978-104.761l-12.181-19.49s12.669,8.283,12.181-38.981c-.487-19-5.847-43.853-22.9-51.65-6.334-2.924-33.621,1.462-36.057,5.36C862.315,242.609,791.175,160.749,702.494,203.628Z",
    transform: "translate(-690.8 -42.767)",
    fill: "#896060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3965",
    "data-name": "Path 3965",
    d: "M729.3,319.317s66.267-45.8,70.653-91.118c0,0-32.159,109.633-63.831,109.633Z",
    transform: "translate(-541.705 100.766)",
    fill: "#704a4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3966",
    "data-name": "Path 3966",
    d: "M690.8,206.1",
    transform: "translate(-690.8 15.181)",
    fill: "#ffbf61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1457",
    "data-name": "Group 1457",
    transform: "translate(304.295 1471.84)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1454",
    "data-name": "Group 1454",
    transform: "translate(74.551 532.088)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3967",
    "data-name": "Path 3967",
    d: "M636.536,577.934V571.6a133.456,133.456,0,0,1-2.436,13.643A42.938,42.938,0,0,1,636.536,577.934Z",
    transform: "translate(-634.1 -571.6)",
    fill: "#191c3c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1455",
    "data-name": "Group 1455",
    transform: "translate(56.035 319.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3968",
    "data-name": "Path 3968",
    d: "M636.634,544.079A73.417,73.417,0,0,0,630.3,528Z",
    transform: "translate(-630.3 -528)",
    fill: "#191c3c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1456",
    "data-name": "Group 1456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3969",
    "data-name": "Path 3969",
    d: "M630.007,477.992c-3.9-5.36-7.309-10.232-11.207-15.593C622.211,467.76,625.622,473.12,630.007,477.992Z",
    transform: "translate(-618.8 -462.4)",
    fill: "#191c3c"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3970",
    "data-name": "Path 3970",
    d: "M1287.01,475.833s-417.094,55.06-573.017,68.7-142.767,468.256-116.455,523.317c25.825,55.06,38.981-55.06,142.767,41.417l103.786,96.477s103.786-82.834,155.436-123.764c51.649-41.417-25.825-261.658,142.767-275.3s565.708,69.191,535.5-254.349C1647.582,227.818,1287.01,475.833,1287.01,475.833Z",
    transform: "translate(-459.398 710.473)",
    fill: "#5e7cad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3971",
    "data-name": "Path 3971",
    d: "M847.865,1032.36c40.93,16.08,73.576,46.777,113.531,64.805,43.854,19.978,87.707,9.258,133.022,0,12.181-2.436,24.85-4.873,37.031-6.334,5.36-112.07,12.182-223.652,19-335.235,6.822-118.4,5.36-242.168-47.264-349.365C1071.03,340.938,999.89,243.974,922.9,245.923c-1.949,0-3.411.487-4.873.487-18.029,3.9-27.774,27.774-40.442,41.9-25.338,28.261-62.857,59.446-80.885,93.067-16.08,29.236-14.618,71.14-18.516,104.274-9.745,79.423-17.541,158.847-24.85,238.757-5.36,56.522-11.207,112.557-16.567,169.079-1.462,13.643-15.1,113.531-14.131,150.076C761.62,1021.64,804.012,1015.793,847.865,1032.36Z",
    transform: "translate(87.431 171.001)",
    fill: "#eabb88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3972",
    "data-name": "Path 3972",
    d: "M701.886,671.64c-14.618,11.207-18.516,27.774-28.261,49.7-23.876,53.6-50.188,105.248-89.656,149.589a35.88,35.88,0,0,0-3.411,42.392s10.72,17.054,11.207,18.029c.487.487,325-201.238,359.6-221.216.487-21.927-42.392-163.719-80.4-124.251-23.388,24.85,2.923,75.525-53.112,76.987-27.286.975-79.423-7.8-104.274,2.436A44.861,44.861,0,0,0,701.886,671.64Z",
    transform: "translate(-483.349 1460.924)",
    fill: "#fdc926"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3973",
    "data-name": "Path 3973",
    d: "M1407.274,748.747s-3.9-341.569-49.7-445.355c-20.952-47.751-83.321-32.159-115.481-5.847-5.847,4.873-10.72,9.745-14.131,15.105-31.185,43.853-20.952,103.786-19.49,154.461.487,17.054,26.312,252.888,33.134,250.939,0,0-263.607,63.344-308.923,74.064C932.2,791.138,645.2,819.4,645.2,824.272c.975,19.49,14.618,32.646,32.646,31.185l52.624-2.924,9.745,11.694c7.8,9.745,19.49,14.618,33.134,13.643l26.312-1.949,70.166,18.029c17.541,4.385,35.083-.487,54.573-12.669v2.436l446.33-53.6C1407.762,825.246,1410.2,785.778,1407.274,748.747Z",
    transform: "translate(-212.269 274.327)",
    fill: "#896060"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1458",
    "data-name": "Group 1458",
    transform: "translate(0 780.661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3974",
    "data-name": "Path 3974",
    d: "M1142.267,443.509,630.644,480.541c-12.181.975-22.414-8.283-23.388-20.465h0c-.975-12.182,8.283-22.414,20.465-23.388l511.623-37.032a21.591,21.591,0,0,1,23.388,20.465h0C1163.707,432.3,1154.448,442.535,1142.267,443.509Z",
    transform: "translate(-359.484 -14.476)",
    fill: "#404560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3975",
    "data-name": "Path 3975",
    d: "M868.44,755.917,585.83,327.616c-4.873-7.309-14.618-9.258-22.414-4.385-7.309,4.873-9.258,14.618-4.385,22.414L829.947,756.4H868.44Z",
    transform: "translate(-556.35 -320.55)",
    fill: "#404560"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1460",
    "data-name": "Group 1460",
    transform: "translate(190.276 1484.996)",
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1459",
    "data-name": "Group 1459"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3976",
    "data-name": "Path 3976",
    d: "M595.4,468.511v1.949c2.923-1.949,5.847-3.411,8.771-5.36Z",
    transform: "translate(-595.4 -465.1)",
    fill: "#191c3c"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3977",
    "data-name": "Path 3977",
    d: "M724.1,172.346s85.758-34.6,131.073,13.643c0,0,88.194,34.6,88.194,128.636s-21.439,128.637,14.131,160.8,83.321,82.834,88.194,139.844c3.411,43.854-30.7,93.067-48.239,130.586-14.618,31.672-19,84.3-38.981,112.07-49.213,67.729-111.583,5.36-110.608-58.471,2.437-139.844-66.755-130.586-28.748-229.5S798.65,383.329,765.03,358.479C731.409,333.141,724.1,172.346,724.1,172.346Z",
    transform: "translate(93.279 -160.335)",
    fill: "#2b2f47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3978",
    "data-name": "Path 3978",
    d: "M698.993,322.678s-48.239-95.016,18.516-133.509c66.755-38.981,171.028,17.054,200.751,77.474s63.344,88.194,88.194,88.194c0,0-102.324,0-148.127-35.083C813.012,284.184,757.951,371.4,698.993,322.678Z",
    transform: "translate(-69.209 -98.71)",
    fill: "#404560"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1480",
    "data-name": "Group 1480",
    transform: "translate(3105.818 14.533)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1479",
    "data-name": "Group 1479"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1462",
    "data-name": "Group 1462",
    transform: "translate(236.981 412.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3979",
    "data-name": "Path 3979",
    d: "M1103.376,248l-188.57,46.777L876.8,669.479l52.137,492.62,501.877,9.745,37.519-486.772-32.646-387.859L1312.9,248Z",
    transform: "translate(-876.8 -248)",
    fill: "#357d93"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3980",
    "data-name": "Path 3980",
    d: "M1316.838,472.554a66.545,66.545,0,0,0-66.755-66.755H952.854A66.546,66.546,0,0,0,886.1,472.554V587.06a66.545,66.545,0,0,0,66.754,66.755h297.229a66.546,66.546,0,0,0,66.755-66.755Z",
    transform: "translate(-603.804 775.719)",
    fill: "#d38888"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1463",
    "data-name": "Group 1463",
    transform: "translate(604.763 758.577)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3981",
    "data-name": "Path 3981",
    d: "M1344.622,319s72.115,286.021,72.115,286.509c7.309,28.261,19,57.984-1.949,82.347-19.978,23.388-61.395,29.723-88.681,39.468-54.086,19-107.685,38.981-161.283,57.984l-69.678,22.9-72.115-22.414-64.805-35.083-5.847-59.446a13.187,13.187,0,0,1,13.156-14.618h68.215l44.34-21.439h-19l-23.875,3.411c-14.618,1.949-27.287-8.771-27.287-23.388,0-19.978,77.475-26.8,92.58-27.287l56.522,55.06,104.273-51.65-76.5-266.044Z",
    transform: "translate(-952.28 -319)",
    fill: "#f5a784"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1464",
    "data-name": "Group 1464",
    transform: "translate(605.836 398.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3982",
    "data-name": "Path 3982",
    d: "M1084.547,415.741a279.546,279.546,0,0,0-27.774-41.417c-22.414-28.261-45.315-56.035-67.729-83.809-6.334-7.8-25.825-42.392-36.544-45.315,96.478,24.85,211.471,29.723,285.047,104.274,46.29,47.264,72.6,110.121,93.554,171.516,4.873,14.618,49.7,175.9,56.522,174.439l-198.315,32.159c-14.13-43.853-28.261-87.707-42.392-132.047C1126.452,533.658,1115.245,472.263,1084.547,415.741Z",
    transform: "translate(-952.5 -245.2)",
    fill: "#357d93"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1465",
    "data-name": "Group 1465",
    transform: "translate(0 758.577)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3983",
    "data-name": "Path 3983",
    d: "M910.2,319s-72.114,286.021-72.114,286.509c-7.309,28.261-19,57.984,1.949,82.347,19.978,23.388,61.395,29.723,88.681,39.468C982.8,746.327,1036.4,766.3,1090,785.307l69.678,22.9,72.114-22.414,64.806-35.083,5.847-59.446a13.187,13.187,0,0,0-13.156-14.618h-68.7l-44.341-21.439h19l23.876,3.411c14.618,1.949,27.286-8.771,27.286-23.388,0-19.978-77.474-26.8-92.579-27.287l-56.522,55.06L993.031,611.356l76.5-266.044Z",
    transform: "translate(-828.164 -319)",
    fill: "#f5a784"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1466",
    "data-name": "Group 1466",
    transform: "translate(38.179 398.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3984",
    "data-name": "Path 3984",
    d: "M1139.075,415.741a279.508,279.508,0,0,1,27.774-41.417c22.414-28.261,45.315-56.035,67.729-83.809,6.334-7.8,25.825-42.392,36.545-45.315-96.478,24.85-211.471,29.723-285.047,104.274-46.29,47.264-72.6,110.121-93.554,171.516-4.873,14.618-49.7,175.9-56.522,174.439l198.315,32.159c14.13-43.853,28.261-87.707,42.392-132.047C1097.171,533.658,1108.378,472.263,1139.075,415.741Z",
    transform: "translate(-836 -245.2)",
    fill: "#357d93"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1467",
    "data-name": "Group 1467",
    transform: "translate(449.913 324.916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3985",
    "data-name": "Path 3985",
    d: "M1013.566,484.35h0A93.058,93.058,0,0,1,920.5,391.283V230h186.133V391.283A93.058,93.058,0,0,1,1013.566,484.35Z",
    transform: "translate(-920.5 -230)",
    fill: "#f5a784"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1468",
    "data-name": "Group 1468",
    transform: "translate(398.372 215.77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3986",
    "data-name": "Path 3986",
    d: "M969.747,320.644S933.2,326,922.482,288c0,0-28.261-76.987,0-80.4,0,0,59.933,38.981,59.933,56.522C982.9,281.663,969.747,320.644,969.747,320.644Z",
    transform: "translate(-909.922 -207.6)",
    fill: "#bc8870"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1469",
    "data-name": "Group 1469",
    transform: "translate(636.047 215.77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3987",
    "data-name": "Path 3987",
    d: "M971.369,320.644S1007.913,326,1018.633,288c0,0,28.749-76.987,0-80.4,0,0-59.933,38.981-59.933,56.522S971.369,320.644,971.369,320.644Z",
    transform: "translate(-958.7 -207.6)",
    fill: "#bc8870"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3988",
    "data-name": "Path 3988",
    d: "M920.5,322.034a135.341,135.341,0,0,0,40.442,37.519c17.541,10.72,38.006,33.134,58.958,33.134,19.978,0,39.468-21.927,56.522-31.672l3.411-1.949a159.795,159.795,0,0,0,26.8-19.978V239.2H920.5v82.834Z",
    transform: "translate(-470.587 130.544)",
    fill: "#bc8870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3989",
    "data-name": "Path 3989",
    d: "M1245.938,221.7c-27.287-55.06-58.471,18.029-134-36.544-75.525-55.06-161.283,6.822-195.391,44.828s17.054,50.188,6.822,91.6,23.876,91.117,23.876,91.117h278.225C1224.986,412.221,1273.224,276.763,1245.938,221.7Z",
    transform: "translate(-531.93 -163.318)",
    fill: "#2b2f47"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1470",
    "data-name": "Group 1470",
    transform: "translate(424.088 115.395)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3990",
    "data-name": "Path 3990",
    d: "M1100.358,531.493l-3.411,1.949c-16.567,9.258-34.108,30.7-54.573,32.159-25.825,1.949-40.442-21.439-60.42-33.621A137.589,137.589,0,0,1,915.2,414.063V187h254.35V411.627C1169.549,461.327,1143.237,507.13,1100.358,531.493Z",
    transform: "translate(-915.2 -187)",
    fill: "#f5a784"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_98_",
    transform: "translate(100.548 659.664)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3991",
    "data-name": "Path 3991",
    d: "M1632.39,322.576a23.914,23.914,0,0,0-23.876-23.876H875.676A23.915,23.915,0,0,0,851.8,322.576V842.482a23.915,23.915,0,0,0,23.876,23.876h732.838a23.915,23.915,0,0,0,23.876-23.876Z",
    transform: "translate(-837.182 -298.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_110_",
    transform: "translate(0 546.705)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_111_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_112_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3992",
    "data-name": "Path 3992",
    d: "M1623.055,466.447H917.5c-21.927,0-68.7-55.547-68.7-55.547h843.446S1645.469,466.447,1623.055,466.447Z",
    transform: "translate(-848.8 -410.9)",
    fill: "#efebe4"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1474",
    "data-name": "Group 1474",
    transform: "translate(67.586 1221.839)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1471",
    "data-name": "Group 1471",
    transform: "translate(115.703 637.948)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_777",
    "data-name": "Rectangle 777",
    width: 141.793,
    height: 184.671,
    transform: "translate(35.9 0) rotate(11.21)",
    fill: "#fdc926"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1472",
    "data-name": "Group 1472",
    transform: "translate(88.525)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3993",
    "data-name": "Path 3993",
    d: "M890.884,1172.373l166.156,33.134s136.919-473.616,165.668-719.683c2.923-25.825-16.567-50.188-44.828-56.035l-58.958-11.694c-108.172-21.439-199.776,45.315-227.063,142.28C821.207,809.852,890.884,1172.373,890.884,1172.373Z",
    transform: "translate(-860.203 -414.075)",
    fill: "#d38888"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1473",
    "data-name": "Group 1473",
    transform: "translate(0 801.664)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3994",
    "data-name": "Path 3994",
    d: "M956.856,578.6,1100.6,604.912c-3.9,48.726,17.054,153,17.054,153-12.668,47.264-12.181,62.369-59.933,52.624-29.723-5.847-60.42-9.745-90.143-15.1-28.749-5.36-57.009-10.72-85.757-16.08-10.72-1.949-32.159-1.462-38.494-11.207-3.411-4.873.487-37.519,5.359-40.93C911.542,675.077,942.726,614.657,956.856,578.6Z",
    transform: "translate(-842.035 -578.6)",
    fill: "#452a51"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1478",
    "data-name": "Group 1478",
    transform: "translate(520.566 1231.706)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1475",
    "data-name": "Group 1475",
    transform: "translate(43.853 654.39)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_778",
    "data-name": "Rectangle 778",
    width: 141.793,
    height: 184.671,
    fill: "#fdc926"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1476",
    "data-name": "Group 1476",
    transform: "translate(0 834.676)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3995",
    "data-name": "Path 3995",
    d: "M1125.518,587.4H979.34C974.468,636.126,935,735.04,935,735.04l5.36,63.831h265.557v-45.8A359.952,359.952,0,0,1,1125.518,587.4Z",
    transform: "translate(-935 -587.4)",
    fill: "#452a51"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1477",
    "data-name": "Group 1477",
    transform: "translate(8.474)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3996",
    "data-name": "Path 3996",
    d: "M1133.4,1200.588H964.322s-41.9-491.157-22.414-738.2c1.949-25.825,25.825-46.29,54.573-46.29h60.42c110.121,0,187.108,83.321,194.9,183.21C1271.783,859.019,1133.4,1200.588,1133.4,1200.588Z",
    transform: "translate(-936.739 -416.1)",
    fill: "#d38888"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3997",
    "data-name": "Path 3997",
    d: "M959.5,216.3a24.893,24.893,0,0,1-.487,4.385c-.487,2.924-1.462,6.822-1.949,11.694-.487,2.436-.975,4.873-1.462,7.8-.487,2.436-1.462,5.36-1.462,8.283-.487,2.924-1.461,5.847-1.461,8.771L951.218,266l-.487,4.385v1.949l-2.924.487-2.923.487h0v-.487h2.923l1.462.975c0,1.462.975,3.411.975,3.9s.487.974.487,1.462l.487,1.462c.487,1.949,1.949,3.411,2.923,4.873a21.642,21.642,0,0,0,5.36,3.9,46.623,46.623,0,0,0,10.232,3.9,15.756,15.756,0,0,0,4.385.975,20,20,0,0,1-4.385,1.949,17.515,17.515,0,0,1-5.36.974,18.407,18.407,0,0,1-7.309,0,25.306,25.306,0,0,1-9.258-2.924,26.8,26.8,0,0,1-4.385-3.411c-1.462-1.462-2.923-2.924-3.411-4.873l-1.461-2.924-.975-3.411a12.457,12.457,0,0,1-.975-5.36v-.974h0v-3.9l.487-5.36c.487-3.411,1.462-6.822,1.949-10.233.487-1.462.975-3.411,1.462-4.873l1.462-4.385a43.161,43.161,0,0,1,3.9-8.283c1.461-2.436,2.436-4.873,3.9-7.309a45.474,45.474,0,0,1,7.309-9.745A8.124,8.124,0,0,1,959.5,216.3Z",
    transform: "translate(-408.238 41.862)",
    fill: "#bc8870"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3998",
    "data-name": "Path 3998",
    d: "M1182.98,203.7s-67.242,63.831-114.993,38.494-63.831-12.669-101.837,6.334-63.831-57.5-51.163-63.831S1180.544,187.622,1182.98,203.7Z",
    transform: "translate(-504.542 -88.307)",
    fill: "#2b2f47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1484",
    "data-name": "Group 1484",
    transform: "translate(2841.409 1846.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3999",
    "data-name": "Path 3999",
    d: "M1419.356,679.931s-58.958,15.1-118.892,27.287-126.687,62.856-125.226,126.2c.974,63.344-76.012,299.177-78.449,321.1s-95.99,223.165-95.99,223.165,587.148,399.066,588.61,400.528c21.927,16.08,54.573-88.681,55.061-107.2,3.9-106.222,0-195.391,5.359-289.919,10.232-191.493,92.092-371.779,51.163-565.708-26.8-128.149-55.061-189.057-112.557-177.85-57.009,11.207-113.532,16.08-113.532,16.08Z",
    transform: "translate(104.793 -163.771)",
    fill: "#4e6fd8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1481",
    "data-name": "Group 1481",
    transform: "translate(0 918.08)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4000",
    "data-name": "Path 4000",
    d: "M1157.555,1390.915c-8.771,12.181-30.21,23.875-61.4,32.646l-307.46-24.85c12.668-6.822,25.337-13.156,36.057-19.491,219.754-133.022,450.228-261.171,619.307-459,59.446-69.191,119.378-145.2,203.674-185.159,78.936-37.519,150.076,77.962,197.827,123.764,93.554,89.168,182.723,186.133,259.709,290.894,133.509,181.748,191.98,289.919,191.98,289.919-133.022,117.43-299.665,78.936-382.5,26.312S1641.4,1070.786,1641.4,1070.786C1565.392,1155.569,1451.86,1184.8,1351,1229.146c-66.755,29.236-132.535,60.42-197.828,91.6C1152.682,1321.724,1177.046,1364.6,1157.555,1390.915Z",
    transform: "translate(-716.585 -727.685)",
    fill: "#5fa1a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4001",
    "data-name": "Path 4001",
    d: "M1150.585,1061.689c-8.284,11.207-25.825,21.439-52.137,29.723L790.5,1066.562C875.77,1014.913,1056.056,907.715,1192,812.7c0,19,7.309,41.417,28.748,66.267a186.741,186.741,0,0,0,64.318,47.751c-75.038,34.6-139.356,64.806-139.356,64.806S1170.075,1035.377,1150.585,1061.689Z",
    transform: "translate(-709.615 -398.46)",
    fill: "#ffe5ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4002",
    "data-name": "Path 4002",
    d: "M1216.332,1015.152l7.309-111.1-165.181-10.72-26.8-52.137-218.78,64.805c-20.952,7.309-36.057,28.749-37.519,53.6L773.9,980.069Z",
    transform: "translate(-773.9 -288.091)",
    fill: "#011948"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4003",
    "data-name": "Path 4003",
    d: "M1296.968,714.1c0-9.258-7.8-15.1-18.516-15.1H1023.616c-10.72,0-18.516,5.847-18.516,15.1v418.556c0,9.258,7.8,15.1,18.516,15.1h254.836c10.72,0,18.516-5.847,18.516-15.1Z",
    transform: "translate(121.445 79.306)",
    fill: "#404560"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1482",
    "data-name": "Group 1482",
    transform: "translate(1120.205 745.659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4004",
    "data-name": "Path 4004",
    d: "M1732.257,692.3c-52.624,14.131-105.735,27.774-158.359,41.9,11.694,75.525,3.9,124.738,15.1,200.263,1.462,11.207-173.952,84.3-187.595,87.22-100.863,21.439-155.923,23.876-155.923,23.876s-36.544-41.9-68.7-49.7c-32.159-7.309-43.366-.975-72.6-2.924s-52.624-3.9-43.366,10.232,18.029,10.72,46.777,12.669c29.235,1.949,56.522,35.57,56.522,35.57l-82.347,46.777s-50.187-15.593-67.242-14.618c-17.541.487-8.284,11.694-8.284,11.694s50.188,15.593,71.14,35.083,54.085,41.417,85.757,39.955,150.076-55.548,151.538-55.548c119.094,10.577,384.311-45.415,390.906-49.191s7.621-2.358,21.307-20S1731.769,817.526,1732.257,692.3Z",
    transform: "translate(-1003.798 -692.3)",
    fill: "#ffe5ce"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4005",
    "data-name": "Path 4005",
    d: "M1107.45,940.607,1087.959,772.99s.487-29.723-16.08-38.006c-16.567-8.771,69.678-106.222,69.678-106.222s100.375-27.774,100.863-27.774c.487-19.978,31.185,185.159,31.185,205.136,0,50.188-1.462,100.863-2.923,151.051Z",
    transform: "translate(371.87 -305.556)",
    fill: "#ffe5ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4006",
    "data-name": "Path 4006",
    d: "M1238.075,620.918s3.411-18.516,3.9-18.516c-1.462-.487-28.261,67.729-30.21,70.653-11.207,13.156-23.876,21.927-39.468,29.236-29.723,13.156-68.216,18.029-100.375,19-2.437-4.385,4.385,2.436,0,0-16.08-8.283,68.216-103.3,68.216-103.3C1171.808,617.994,1206.891,615.071,1238.075,620.918Z",
    transform: "translate(372.318 -294.789)",
    fill: "#6496b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4007",
    "data-name": "Path 4007",
    d: "M1320.413,578.4c142.279,78.448,123.277,259.222,50.188,355.212s-158.847,98.426-158.847,98.426,93.066-149.1,16.567-242.655,56.035-142.767-67.242-120.353L1064.6,563.3C1064.114,563.784,1177.646,499.953,1320.413,578.4Z",
    transform: "translate(351.863 -539.269)",
    fill: "#704a4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4008",
    "data-name": "Path 4008",
    d: "M1082.795,586.874c-39.955,48.726-40.442,159.334-21.926,216.343,0,0,25.337,77.962,40.442,92.092,0,0,22.9,20.952,67.242,6.334l69.191-22.414a76.741,76.741,0,0,0,47.751-45.8c3.9-10.232,7.8-20.952,12.182-31.185-1.462,3.9,37.031-8.283,41.417-12.181,10.232-9.745,15.592-26.8,19-40.443,6.821-24.363,10.719-63.831-26.8-43.366l-22.9,23.388s-4.873-.487-5.359-.975c1.949.487-1.949-60.42-3.9-66.267-6.822-22.9-21.439-39.468-38.981-55.06-29.723-26.312-85.757-65.293-127.662-47.751C1118.852,564.947,1093.027,574.2,1082.795,586.874Z",
    transform: "translate(291.765 -477.575)",
    fill: "#ffe5ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4009",
    "data-name": "Path 4009",
    d: "M1057.926,641.673l18.028-54.573h0l-4.386,51.162c-4.385,12.668,10.232,22.9,26.8,18.516l-13.644,3.411C1068.158,664.087,1053.54,654.342,1057.926,641.673Z",
    transform: "translate(322.969 -354.038)",
    fill: "#6496b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4010",
    "data-name": "Path 4010",
    d: "M1328.477,907.614s27.287-217.805-71.627-258.248c-98.426-40.443-184.184,8.771-134,252.888C1173.528,1146.858,1328.477,907.614,1328.477,907.614Z",
    transform: "translate(520.186 -161.954)",
    fill: "#4e6fd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4011",
    "data-name": "Path 4011",
    d: "M1283.065,640s-82.834,143.254-182.235,73.576,94.528,289.92,94.528,289.92S1390.263,868.037,1283.065,640Z",
    transform: "translate(382.388 -149.178)",
    fill: "#4e6fd8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1483",
    "data-name": "Group 1483",
    transform: "translate(137.355 966.908)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4012",
    "data-name": "Path 4012",
    d: "M1182.532,1453.458c-7.8,13.156-27.774,26.8-57.5,39.468L816.6,1501.209c11.694-8.283,23.876-16.08,33.621-23.388,204.162-155.923,419.531-307.948,566.683-522.83,51.649-75.038,103.3-157.385,182.723-206.111,74.55-45.8,157.872,61.395,210.009,101.837,102.812,78.936,201.726,165.668,289.432,261.171,152.025,166.156,221.7,267.993,221.7,267.993-119.378,131.073-289.432,110.608-377.139,67.242-88.194-43.366-314.282-363.5-314.282-363.5-66.755,92.579-176.388,134-271.891,188.569-62.856,36.058-125.226,74.551-187.107,112.557C1169.863,1384.755,1198.611,1424.71,1182.532,1453.458Z",
    transform: "translate(-745.895 -737.707)",
    fill: "#94cbd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4013",
    "data-name": "Path 4013",
    d: "M1175.948,1084.426c-6.822,11.694-23.388,23.876-48.726,35.57L818.3,1128.279c78.936-60.42,247.041-186.62,371.779-295.279,1.949,19,11.694,40.442,36.058,62.857,22.9,20.952,46.776,33.621,69.191,40.442-70.653,42.392-131.56,79.423-131.56,79.423S1192.028,1055.677,1175.948,1084.426Z",
    transform: "translate(-739.311 -368.675)",
    fill: "#ffe5ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4014",
    "data-name": "Path 4014",
    d: "M1246.522,1019.487l-4.873-111.1-165.181,6.822L1044.31,866l-210.5,87.707c-19.978,9.258-32.646,32.159-31.672,57.009l.975,20.465Z",
    transform: "translate(-802.089 -240.878)",
    fill: "#011948"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4015",
    "data-name": "Path 4015",
    d: "M1076.366,567.628a98.335,98.335,0,0,1,20.465-14.618c43.366-22.9,99.4,0,137.407,24.363,65.78,42.392,58.958,99.4,85.758,165.181,4.385,11.207,19.978,47.751,35.083,50.675-.487,0-42.879-7.8-106.71-81.372-52.137-60.42-118.4,8.771-174.439-31.185C1032.512,650.949,1044.694,598.325,1076.366,567.628Z",
    transform: "translate(285.525 -522.648)",
    fill: "#896060"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1491",
    "data-name": "Group 1491",
    transform: "translate(790.081 583.423)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1490",
    "data-name": "Group 1490"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1489",
    "data-name": "Group 1489",
    transform: "translate(172.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1488",
    "data-name": "Group 1488"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1485",
    "data-name": "Group 1485",
    transform: "translate(85.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4016",
    "data-name": "Path 4016",
    d: "M598.717,738.007s122.79-20.952,124.251-62.369C725.892,566.979,579.227,321.4,579.227,321.4L431.1,393.514Z",
    transform: "translate(-307.796 -120.019)",
    fill: "#f5a784"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4017",
    "data-name": "Path 4017",
    d: "M452.6,437.111s-64.805-37.519-41.9-75.525c22.9-38.494-13.156-73.576,62.856-79.911s83.322,7.8,127.662,12.669c44.828,4.385,118.891,7.8,153,72.114s-15.105,234.859-15.105,234.859Z",
    transform: "translate(-405.794 -280.071)",
    fill: "#2b2f47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4018",
    "data-name": "Path 4018",
    d: "M441.086,302.226a316.621,316.621,0,0,0-25.338,65.78c-9.745,38.006,15.592,65.78,11.694,100.863-2.436,19.978-19.49,38.006-17.054,58.958,2.436,24.363,32.159,13.156,34.6,19.49l36.057,90.63a38.337,38.337,0,0,0,53.111,19.978l91.117-42.879c55.548-26.312,32.646-93.067,38.981-140.331,5.36-40.93,54.573-75.038,0-103.786-7.309-3.9-38.493-4.873-41.9-.975-7.8,7.8-14.618,44.341-18.029,62.369-.487,1.949-3.411,2.436-3.9,0C591.162,396.268,549.745,271.042,441.086,302.226Z",
    transform: "translate(-388.922 -213.402)",
    fill: "#f5a784"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4019",
    "data-name": "Path 4019",
    d: "M446.8,436.468s83.809-38.494,97.939-89.168c0,0-57.5,117.43-94.041,111.1Z",
    transform: "translate(-246.996 -19.718)",
    fill: "#67a3a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4020",
    "data-name": "Path 4020",
    d: "M417,516.095s5.847,78.936,23.876,92.092c26.8,19,33.621,31.672,61.395,20.465s148.614-50.675,133.022-120.84c-2.436-10.233-.487-24.363-4.873-33.621-4.873-9.745-12.181-9.258-16.567-16.079-8.771-13.643-10.233-30.21-12.669-45.8-2.436-16.079-2.436-94.528-20.465-101.837-15.105-5.847-25.338,15.105-15.592,52.624s19.49,94.528-11.694,105.248C521.761,479.063,438.927,464.932,417,516.095Z",
    transform: "translate(-362.399 -166.099)",
    fill: "#2b2f47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4021",
    "data-name": "Path 4021",
    d: "M415.074,369.924s104.274,54.086,154.461,26.8C619.723,369.924,593.9,313.4,593.9,313.4S377.555,243.237,415.074,369.924Z",
    transform: "translate(-386.786 -226.04)",
    fill: "#2b2f47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1487",
    "data-name": "Group 1487",
    transform: "translate(0 486.407)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_779",
    "data-name": "Rectangle 779",
    width: 130.098,
    height: 235.346,
    transform: "matrix(-1, 0.014, -0.014, -1, 372.249, 2515.732)",
    fill: "#f5a784"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1486",
    "data-name": "Group 1486",
    transform: "translate(77.976 847.854)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_780",
    "data-name": "Rectangle 780",
    width: 130.098,
    height: 235.346,
    transform: "translate(491.881 1620.003) rotate(171.911)",
    fill: "#f5a784"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4022",
    "data-name": "Path 4022",
    d: "M404.3,557.311c30.21,213.42,65.293,427.327,91.118,641.234,23.388,196.365,91.118,379.575,148.614,567.17,6.822,21.44,95.5,327.926,103.3,326.464l153-21.927c-56.522-303.562-124.739-602.74-129.124-912.637-.975-77.962-14.131-156.41-6.334-233.885C772.181,847.718,817.5,791.2,831.14,718.594c11.207-58.958,0-108.659-16.08-164.694Z",
    transform: "translate(-404.3 -553.9)",
    fill: "#331143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4023",
    "data-name": "Path 4023",
    d: "M819.92,980.755l-13.643-96.964L662.048,904.255,629.4,864.3,452.526,959.8c-16.567,10.232-25.825,31.185-22.9,53.111l2.437,18.029Z",
    transform: "translate(-308.297 648.154)",
    fill: "#9496a4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4024",
    "data-name": "Path 4024",
    d: "M406.6,554.4c2.924,215.856,10.72,431.712,8.771,647.568-1.462,197.34,42.392,388.346,75.525,581.788,3.9,22.414,53.111,337.184,60.907,337.184l154.461-1.949C688.723,1811.043,659,1505.531,693.6,1197.1c8.771-77.474,5.847-156.9,23.388-232.91,17.054-74.551,69.191-124.739,92.092-195.391,18.516-57.009,13.643-107.684,4.873-165.668Z",
    transform: "translate(-317.417 295.89)",
    fill: "#452a51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4025",
    "data-name": "Path 4025",
    d: "M850.969,380.4c25.825-7.309,53.6,66.267,57.5,82.347,11.694,53.111-6.334,105.248-9.258,157.872-4.873,83.322-13.643,166.156-19,248.99-10.72,163.719-26.312,327.438-39.468,491.158-2.924,35.57-259.709-40.443-431.712-60.42-12.182-3.9,1.949-189.057,2.436-205.136,4.385-212.445,3.411-440.97,157.385-606.638,10.232-11.207,97.939-93.067,86.732-108.172,19.49,27.287,54.086,38.981,86.245,30.21C741.335,410.615,849.507,380.892,850.969,380.4Z",
    transform: "translate(-327.15 -379.895)",
    fill: "#9bb8bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4026",
    "data-name": "Path 4026",
    d: "M779.581,1009.743,778.119,911.8l-145.691,1.949L605.142,869.9l-187.6,72.115c-18.029,7.8-29.723,27.774-29.236,49.7l.487,18.029H779.581Z",
    transform: "translate(-388.297 1517.694)",
    fill: "#9496a4"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_4027",
    "data-name": "Path 4027",
    d: "M469.541,449.707S566.993,425.831,604.025,362c0,0,67.242,74.063,74.064,91.118S452,574.445,452,574.445Z",
    transform: "translate(-141.601 37.209)",
    fill: "#72a3aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4028",
    "data-name": "Path 4028",
    d: "M514.851,380,440.3,464.3l74.063-50.675Z",
    transform: "translate(-186.91 106.916)",
    fill: "#72a3aa"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4029",
    "data-name": "Path 4029",
    d: "M356.964,854.509a18.453,18.453,0,0,0,0-7.309h46.29l107.684,69.191,279.2-105.248L821.322,441.8h186.133L940.7,854.509c-9.258,58.958-57.984,103.3-117.429,108.172L502.654,988.018H443.209l-85.271-61.395C351.6,903.235,353.066,878.872,356.964,854.509Z",
    transform: "translate(-350.178 346.242)",
    fill: "#f5a784"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4030",
    "data-name": "Path 4030",
    d: "M446.7,653.565v-71.14c0-82.347,63.344-229.5,176.875-156.9,46.777,29.723,40.442,130.586,40.442,181.748v46.29H446.7Z",
    transform: "translate(10.314 207.566)",
    fill: "#9bb8bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4031",
    "data-name": "Path 4031",
    d: "M425.474,543.249s-49.7-35.083-65.78-12.181,1.462,35.57,1.462,35.57a27.928,27.928,0,0,0-2.436,30.21c8.771,17.054,0,21.439,24.363,32.159s49.7,51.649,62.857,38.981C458.607,655.318,425.474,543.249,425.474,543.249Z",
    transform: "translate(-352.907 661.888)",
    fill: "#f5a784"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1499",
    "data-name": "Group 1499",
    transform: "translate(4193.555 1001.635)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4053",
    "data-name": "Path 4053",
    d: "M0,0H607.613V159.821H0Z",
    transform: "translate(27.774 294.305)",
    fill: "#ffd878"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_782",
    "data-name": "Rectangle 782",
    width: 607.613,
    height: 83.321,
    transform: "translate(27.774 294.305)",
    fill: "#fdc926"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_783",
    "data-name": "Rectangle 783",
    width: 658.775,
    height: 175.901,
    transform: "translate(85.27)",
    fill: "#8b5e5e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_784",
    "data-name": "Rectangle 784",
    width: 492.132,
    height: 175.901,
    transform: "translate(251.426)",
    fill: "#d38888"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_785",
    "data-name": "Rectangle 785",
    width: 735.275,
    height: 114.993,
    transform: "translate(0 178.824)",
    fill: "#47a0a8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_786",
    "data-name": "Rectangle 786",
    width: 594.457,
    height: 57.497,
    transform: "translate(143.742 208.06)",
    fill: "#377883"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1498",
    "data-name": "Group 1498",
    transform: "translate(307.948 67.238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1493",
    "data-name": "Group 1493",
    transform: "translate(0 0.978)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1492",
    "data-name": "Group 1492"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4032",
    "data-name": "Path 4032",
    d: "M1243.724,379.9H1137.988c-31.185,0-31.185,48.726,0,48.726h105.735c31.185,0,31.185-48.726,0-48.726Z",
    transform: "translate(-1114.6 -379.9)",
    fill: "#d4dadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1495",
    "data-name": "Group 1495",
    transform: "translate(163.537 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1494",
    "data-name": "Group 1494"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4033",
    "data-name": "Path 4033",
    d: "M1220.459,379.7c-16.08,0-32.646.487-48.726.975-31.185.974-31.672,49.7,0,48.726,16.08-.487,32.646-.975,48.726-.975,31.672-.487,31.672-49.213,0-48.726Z",
    transform: "translate(-1148.162 -379.699)",
    fill: "#d4dadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1497",
    "data-name": "Group 1497",
    transform: "translate(273.17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1496",
    "data-name": "Group 1496"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4034",
    "data-name": "Path 4034",
    d: "M1241.01,380.677c-15.592-.487-31.185-.974-46.777-.974-31.672-.487-31.185,48.239,0,48.726,15.592,0,31.185.487,46.777.974,13.156.487,24.363-11.207,24.363-24.363,0-13.643-11.207-23.876-24.363-24.363Z",
    transform: "translate(-1170.662 -379.699)",
    fill: "#d4dadc"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_787",
    "data-name": "Rectangle 787",
    width: 105.735,
    height: 159.821,
    transform: "translate(484.823 294.305)",
    fill: "#fee597"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1508",
    "data-name": "Group 1508",
    transform: "translate(389.928 173.846)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1505",
    "data-name": "Group 1505"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1502",
    "data-name": "Group 1502",
    transform: "translate(5316.564 1397.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4038",
    "data-name": "Path 4038",
    d: "M1336.912,502.777l-21.439,10.232L1305.24,491.57c-3.411-6.822-11.208-9.745-18.028-6.334s-9.746,11.207-6.335,18.029l10.232,21.439-21.439,10.233c-6.822,3.411-9.745,11.207-6.334,18.029s11.207,9.745,18.028,6.334l21.439-10.232,10.232,21.439c3.411,6.822,11.207,9.745,18.028,6.334s9.745-11.207,6.334-18.029l-10.232-21.439,21.44-10.232c6.821-3.411,9.745-11.207,6.334-18.029C1352.017,502.29,1343.733,499.853,1336.912,502.777Z",
    transform: "translate(-1006.136 -244.453)",
    fill: "#7aa7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4039",
    "data-name": "Path 4039",
    d: "M1288.748,443.044l-9.258,21.927-21.927-9.258c-6.822-2.924-14.618.487-18.028,7.309-2.924,6.822.487,14.618,7.309,18.029l21.927,9.258-9.258,21.927a13.437,13.437,0,0,0,7.309,17.542,13.987,13.987,0,0,0,18.028-7.309l9.258-21.927,21.927,9.258c6.822,2.924,15.1-.487,17.541-7.309a13.987,13.987,0,0,0-7.309-18.029L1304.34,475.2l9.258-21.927a13.438,13.438,0,0,0-7.309-17.542C1299.955,432.812,1291.671,436.223,1288.748,443.044Z",
    transform: "translate(-1096.841 -434.684)",
    fill: "#f4bf98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4040",
    "data-name": "Path 4040",
    d: "M1257.58,482.359a25.286,25.286,0,1,1-33.621-12.182A25.3,25.3,0,0,1,1257.58,482.359Z",
    transform: "translate(-1209.415 -306.382)",
    fill: "#fdc926"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1503",
    "data-name": "Group 1503",
    transform: "translate(2241.14 82.681)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4041",
    "data-name": "Path 4041",
    d: "M660.383,207.384l3.9,23.876-23.876,3.9c-7.309.974-12.181,8.283-11.207,15.592s8.283,12.181,15.593,11.207l23.876-3.9,3.9,23.876a13.389,13.389,0,0,0,15.593,11.207c7.309-.974,12.181-8.283,11.207-15.592l-3.9-23.876,23.876-3.9c7.309-.975,12.182-8.283,11.207-15.592a13.389,13.389,0,0,0-15.592-11.207l-23.876,3.9L687.182,203a13.389,13.389,0,0,0-15.592-11.207A14.023,14.023,0,0,0,660.383,207.384Z",
    transform: "translate(-381.416 -60.947)",
    fill: "#7aa7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4042",
    "data-name": "Path 4042",
    d: "M583.862,225.837l19.49,14.13-14.131,19.49c-4.385,5.847-2.924,14.618,2.923,19s14.618,2.924,19-2.924l14.131-19.49,19.49,14.13c5.847,4.385,14.618,2.924,19-2.924s2.924-14.618-2.923-19l-19.49-14.13,14.131-19.49c4.385-5.847,2.924-14.618-2.923-19a13.787,13.787,0,0,0-19,2.924l-14.131,19.49-19.49-14.13c-5.847-4.385-14.618-2.924-19,2.924S577.528,220.964,583.862,225.837Z",
    transform: "translate(-578.248 -55.037)",
    fill: "#f4bf98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4043",
    "data-name": "Path 4043",
    d: "M636.058,165.006c13.643-1.949,26.8,7.309,28.749,20.952s-7.309,26.8-20.952,28.748-26.8-7.309-28.748-20.952A25.568,25.568,0,0,1,636.058,165.006Z",
    transform: "translate(-436.514 -164.747)",
    fill: "#fdc926"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1504",
    "data-name": "Group 1504",
    transform: "translate(4372.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4044",
    "data-name": "Path 4044",
    d: "M1105.256,196.982,1088.2,213.549l-16.567-17.054a13.437,13.437,0,0,0-19,19l16.567,17.054-17.054,16.567a13.693,13.693,0,0,0-.487,19,13.239,13.239,0,0,0,19,0l17.054-16.567,16.567,17.054a13.239,13.239,0,0,0,19,0,13.692,13.692,0,0,0,.487-19l-16.567-17.054,17.054-16.567a13.692,13.692,0,0,0,.487-19C1118.9,191.622,1110.616,191.622,1105.256,196.982Z",
    transform: "translate(-889.887 25.314)",
    fill: "#7aa7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4045",
    "data-name": "Path 4045",
    d: "M1053.606,160.553l-.487,23.876-23.876-.487a13.643,13.643,0,0,0,0,27.287l23.876.487-.487,23.876c0,7.309,5.847,13.643,13.156,13.643s13.644-5.847,13.644-13.156l.487-23.876,23.876.487c7.309,0,13.644-5.847,13.644-13.156s-5.847-13.643-13.156-13.643l-23.876-.487.487-23.876c0-7.309-5.847-13.643-13.156-13.643C1059.453,146.91,1053.606,152.757,1053.606,160.553Z",
    transform: "translate(-1015.6 -147.778)",
    fill: "#f4bf98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4046",
    "data-name": "Path 4046",
    d: "M1109.176,168.949a24.862,24.862,0,0,1-.487,35.57c-9.746,9.745-25.825,9.258-35.57-.487s-9.258-25.825.487-35.57A24.861,24.861,0,0,1,1109.176,168.949Z",
    transform: "translate(-820.231 -95.753)",
    fill: "#fdc926"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1506",
    "data-name": "Group 1506",
    transform: "translate(5193.335 552.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4047",
    "data-name": "Path 4047",
    d: "M1224.458,306.906c-11.208,8.284-26.8,5.36-35.083-5.847s-5.36-26.8,5.847-35.083,26.8-5.36,35.083,5.847A25.538,25.538,0,0,1,1224.458,306.906Z",
    transform: "translate(-1182.188 -261.225)",
    fill: "#f6f6f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4048",
    "data-name": "Path 4048",
    d: "M1223.958,337.506c-11.207,8.283-26.8,5.36-35.083-5.847s-5.359-26.8,5.847-35.083,26.8-5.36,35.083,5.847A25.538,25.538,0,0,1,1223.958,337.506Z",
    transform: "translate(-1184.125 -142.723)",
    fill: "#f6f6f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4049",
    "data-name": "Path 4049",
    d: "M1241.559,326.306c-11.208,8.284-26.8,5.36-35.083-5.847s-5.36-26.8,5.847-35.083,26.8-5.36,35.083,5.847A25.538,25.538,0,0,1,1241.559,326.306Z",
    transform: "translate(-1115.967 -186.096)",
    fill: "#f6f6f8"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStanfordTeam);
export default __webpack_public_path__ + "static/media/stanfordTeam.6bd7634c28ddfdc8ba5637da0691641b.svg";
export { ForwardRef as ReactComponent };